import HappeningNonContent from 'components/HappeningNonContent/HappeningNonContent';
import { withHappeningNonContentProps } from 'viewModel/happening/withHappeningNonContentProps';

export default withHappeningNonContentProps(HappeningNonContent);
